// HomeWeb.jsx
import React, {useEffect} from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/celerWebStyles';
import { useLogScreen } from '../useLogScreen';

export default function CelerWeb() {
    useLogScreen('CelerView');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Home Staging';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();

    return (
        <BaseWeb>
            {(userInfo) => {
                const usuario_id = userInfo?.id;
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Home Staging</Text>

                        <View style={styles.container}>

                            <View style={styles.row}>
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>
                                    Home Staging virtual é a técnica de decorar digitalmente um imóvel, criando imagens realistas e atraentes para anúncios online. Com essa estratégia, é possível transformar espaços vazios ou antigos em ambientes modernos e acolhedores, ajudando os compradores a visualizar o potencial da propriedade.
                                </Text>
                            </View>

                            <View style={styles.row}>
                                <View style={styles.optionButtonsContainer}>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => Linking.openURL('https://cdn.imogo.com.br/manuais/manual_celer_imogo.pdf')}>
                                        <Image
                                            source={require('../assets/icons/info.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Manual Home Staging</Text>
                                        </View>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={styles.optionButton} onPress={() => Linking.openURL('https://wa.me/5531971354449?text=Ol%C3%A1,%20gostaria%20de%20solicitar%20um%20projeto%20com%20a%20imoGo.')}> 
                                        <Image
                                            source={require('../assets/icons/whatsapp.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Solicitar novo projeto</Text>
                                        </View>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('ListaProjetosWeb', { usuario_id })}>
                                        <Image
                                            source={require('../assets/icons/files.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Meus projetos</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </View>

                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home', { usuario_id })}>
                                    <Image
                                        source={require('../assets/icons/home.png')}
                                        style={styles.laterIcon}
                                    />
                                    <Text style={styles.laterButtonText} allowFontScaling={false}>Voltar pra home</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}